import { render, staticRenderFns } from "./RejectModal.vue?vue&type=template&id=67a62529&"
import script from "./RejectModal.vue?vue&type=script&lang=js&"
export * from "./RejectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports